import { createFileRoute } from '@tanstack/react-router';
import { EmptyState } from '@/components/page-header';
import { ReceivePaymentForm } from '@/components/sales/receive-payment-form';
import { useOrgId } from '@/lib/org';

export const Route = createFileRoute('/sales/receive-payment/new')({
  component: New,
  validateSearch: (s: Record<string, unknown>): { contactId?: string; invoiceId?: string } => ({
    ...(typeof s['contactId'] === 'string' ? { contactId: s['contactId'] } : {}),
    ...(typeof s['invoiceId'] === 'string' ? { invoiceId: s['invoiceId'] } : {}),
  }),
});

function New() {
  const orgId = useOrgId();
  const s = Route.useSearch();
  if (!orgId)
    return <EmptyState title="Select a client" hint="Use the client switcher in the top bar." />;
  return <ReceivePaymentForm key={`${orgId}-${s.contactId ?? ''}-${s.invoiceId ?? ''}`} {...s} />;
}
